import React, { useState } from 'react';

/**
 * 
 * @param {Object} props 
 * @param {boolean} props.labelHidden - whether to hide the label
 * @param {string} props.label - the label of the select
 * @param {string} props.className - the class name of the select
 * @param {string} props.labelClassName - the class name of the label
 * @param {string} props.selectClassName - the class name of the select input
 * @param {function} props.onChange - the function to call when the value changes
 * @param {string} props.value - the value of the select
 * @param {boolean} props.disabled - whether the select is disabled
 * @param {Array} props.options - the options of the select
 * @returns 
 */
export default function (props) {
  return (
    <div className={props.className}>
      {
        props.labelHidden ? null
          : (
            <label htmlFor="email" className={`block text-sm font-medium text-gray-700 mb-2 ${props.labelClassName}`}>
              {props.label}
            </label>
          )
      }
      <select
        className={`block w-full pl-3 pr-10 py-2 text-base border border-solid border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md ${props.selectClassName}`}
        onChange={props.onChange}
        value={props.value}
        disabled={props.disabled}
      >
        {
          props.options.map((i) => (
            <option key={i.value} selected={i.value == props.value} value={i.value}>{i.label}</option>
          ))
        }
      </select>
    </div>
  );
}
